import React, { useEffect } from 'react';
import havana from '../../../data/havana.js';
import * as d3 from "d3";

function View03 (props){

    const biobanks = props.biobanks,
        extra = props.extra,
        getExtra = props.getExtra,
        codV = props.codV,
        settings = props.settings,
        locus = props.locus,
        wholeDataset = props.wholeDataset,
        pos = props.pos,
        chr = props.chr,
        refV = props.refV,
        altV = props.altV,
        AF = props.AF,
        AFs = props.AFs,
        PIPs = props.PIPs,
        betas = props.betas,
        defineMinPval = props.defineMinPval,
        format = props.format;

    const size = {
        margin:{ 
            top: 48,
            mid: 150,
            left: getExtra(390, 360, 330),
            gutter: 40,
            bottom: 30,
        },
        width: props.width,
        height: 400,
        unit: 30
    };
    const [inspection, setInspection] = React.useState({})
    const [hover, setHover] = React.useState()

    const colors = [
        'rgb(242, 13, 13)',
        'rgb(13, 13, 242)',
        'rgb(13, 242, 13)',
        'rgb(242, 105, 13)',
        'rgb(105, 13, 242)',
        'rgb(13, 242, 105)',
        'rgb(242, 242, 13)',
        'rgb(242, 13, 242)',
        'rgb(13, 242, 242)',
        'rgb(242, 242, 242)',
        'rgb(242, 13, 105)',
        'rgb(13, 105, 242)',
        'rgb(105, 242, 13)',
        'rgb(105, 105, 105)',
    ]

    const elements = wholeDataset[locus.chr-1][1].filter(el => el[pos] >= locus.low && el[pos] <= locus.high)
    const paths = biobanks.map(bb => ({
        biobank: bb, 
        elements: elements.map(el => ({
            pos: el[pos],
            pval: el[bb],
        }))
    }))
    const circles = getCircles(codV, locus, elements)
    const minPval = getMinPval(biobanks)

    const scalePosToUI = d3.scaleLinear()
        .domain([locus.low, locus.high])
        .range([size.margin.left, size.width])

    const scalePvalToUI = d3.scaleLog()
        .domain([minPval, 1])
        .range([size.margin.top+10, size.height+size.margin.top])

    function colorBiobank (a) {
        for (let i = 0; i < 14; i++) {
            if (a === i) return colors[i]
        }
    }

    function locatePval (datum,bbN){
        if (Number.isNaN(datum) || datum === 0) return size.height+size.margin.top+size.margin.bottom + (bbN+1)*6
        else return scalePvalToUI(datum)
    }

    function getCircles (codV, locus, elements) {
        
        const genes = havana.filter(el => el.chromosome === locus.chr && el.stop > locus.low && el.start < locus.high)
        const codVLocus = codV[locus.chr-1][1].filter(item => +item.pos > locus.low && +item.pos < locus.high)

        function getCodV (el) {
            const codVList = codVLocus.filter(item => +item.pos === el[pos])
            if (codVList.length === 1) {
                const codVItem = codVList[0]
                if (codVItem.ref === el[refV] && codVItem.alt === el[altV]) return codVItem.most_severe
                else return undefined
                }
            else return undefined
        }

        function getGenes (el) {
            return genes.filter(item => el[pos] <= item.stop && el[pos] >= item.start).map(item => item.gene_name)
        }
        
        const circles = elements.map(el => ({
            chr: el[chr],
            pos: el[pos],
            refV: el[refV],
            altV: el[altV],
            codV: getCodV(el),
            genes: getGenes(el),
            af: el[AF],
            values: biobanks.map((item,i) => ({
                biobank: item,
                pval: el[item],
                beta: Number(el[betas[i]]),
                pip: Number(el[PIPs[i]]),
                af: Number(el[AFs[i]])
            }))
        }))

        return circles
    }

    function getMinPval (biobanks) {
        const biobanksList = biobanks.map(bb => ({
            biobank: bb, 
            minPval: defineMinPval(elements, bb),
            }))
        
        const minPval = d3.min(biobanksList, el => el.minPval);
        return minPval
    }

    function drawPaths (data) {

        function getPath (data, bbN) {
            var points = ""
            data.forEach((el, i) => {
                var elX = scalePosToUI(el.pos)
                var elY = locatePval(el.pval,bbN)
                if (i === 1) {points = points + " L" + elX + "," + elY}
                else points = points + " " + elX + "," + elY
            })
            return "M" + points
        }

        d3.select('#paths03').selectAll('path').data(data).join(
            function(enter){
                enter.append('path')
                    .attr('class', d => d.biobank)
                    .attr('fill', 'none')
                    .style('opacity', 0)
                    .style('transition', 'opacity 1s')
                    .attr('stroke-width', '2px')
                    .attr('stroke', (d,i) => colorBiobank(i))
                    .attr('d', (d,i) => getPath(d.elements,i))
            },
            function(update){
                update.attr('d', (d,i) => getPath(d.elements,i))
            }
        )
    }

    function drawInspectionList (data) {

        function showPath (bb) {
            d3.select('#paths03').select('.'+bb).style('opacity', 0.7);
            d3.select('#circles03').selectAll('circle').style('opacity', 0.4);
            d3.select('#circles03').selectAll('.'+bb).style('opacity', 1);
            d3.select('#biobanks03').selectAll('text').style('opacity', 0.4);
            d3.select('#biobanks03').selectAll('circle').style('opacity', 0.4);
            d3.select('#biobanks03').select('.'+bb).selectAll('text').style('opacity', 1);
            d3.select('#biobanks03').select('.'+bb).select('circle').style('opacity', 1);
        }
    
        function hidePath () {
            d3.select('#paths03').selectAll('path').style('opacity', 0);
            d3.select('#circles03').selectAll('circle').style('opacity', 1);
            d3.select('#biobanks03').selectAll('g').selectAll('text, circle').style('opacity', 1);
        }

        function hideBB (bb) {
            d3.select('#thumbnail03').selectAll('.'+bb).style('display', 'none');
            d3.select('#biobanks03').select('.'+bb).style('opacity', 0.2).classed('faded', true)
        }
    
        function showBB (bb) {
            d3.select('#thumbnail03').selectAll('.'+bb).style('display', 'block');
            d3.select('#biobanks03').select('.'+bb).style('opacity',1).classed('faded', false);
        }

        var active = Object.keys(inspection).length > 0

            const locus = active ? data.chr + ':' + data.pos + ':' + data.refV + ':' + data.altV : 'Hover on dots to inspect the loci.'
            
            const bbList = active ? data.values : biobanks.map(bb => {return {
                biobank: bb,
                pval: undefined,
                beta: undefined,
                af: undefined,
            }
                
            });
            
            const locusList = [
                {name: 'Coding variant',   type: 'cd', value: data.codV},
                {name: 'Genes',            type: 'gn', value: data.genes},
                {name: 'Allele frequency', type: 'af', value: data.af}
            ]
            if (extra.af) locusList.pop()
    
            const heightMore = 100 + (bbList.length+1)*size.unit + size.margin.top + size.margin.bottom,
                heightLess = size.height + size.margin.top + size.margin.bottom + size.unit,
                variant = active ? data.chr + '_' + data.pos + '_' + data.refV + '_' + data.altV : ''
    
            d3.select("#chart03").attr("height", heightLess > heightMore ? heightLess : heightMore);
            d3.select('#link_finngen').on('click', () => {window.open('https://results.finngen.fi/variant/' + variant,'_blank');})
            d3.select('#link_opentargets').on('click', () => {window.open('https://genetics.opentargets.org/variant/' + variant,'_blank');})
            d3.select('#locus_name').html(locus)
    
            d3.select('#specifics03').style('display', 'block').selectAll('g').data(locusList).join(
                function(enter){
                    var locusItem = enter.append('g')
                    locusItem.append('text')
                        .attr('x', 0)
                        .attr('y', (d,i) => size.margin.top+12*i+38)
                        .html(d => d.name)
                        .attr('class', 'smallText')
    
                    locusItem.append('text')
                        .attr('x', 120)
                        .attr('y', (d,i) => size.margin.top+12*i+38)
                        .html(d => format(d.type, d.value))
                        .attr('class', 'smallText value')
                    return locusItem
                    },
                function(update){update.select('.value').html(d => format(d.type, d.value))}
            )
    
            d3.select('#biobanks03').style('display', 'block').selectAll('g').data(bbList).join(
                function(enter){

                    var bbItem = enter.append('g')
                        .attr('class', d => d.biobank)
                        .style('transition', 'opacity 0.5s')
                        .style('cursor', 'pointer')
                        .on('mouseenter', (e,d) => showPath(d.biobank))
                        .on('mouseleave', e => hidePath())
                        .on('click', (e,d) => {d3.select('#biobanks03').select('.'+d.biobank).classed('faded') ? showBB(d.biobank) : hideBB(d.biobank)})
                    
                    bbItem.append('line')
                        .attr('x1',0).attr('y1',(d,i) => size.unit*(i+1)+size.margin.top+size.margin.mid)
                        .attr('x2',size.margin.left - size.margin.gutter).attr('y2',(d,i) => size.unit*(i+1)+size.margin.top+size.margin.mid)
                        .attr('class', 'normalLine')
                    bbItem.append('text')
                        .html(d => format('bbshort', d.biobank))
                        .attr('x',35).attr('y', (d,i) => size.unit*i+size.margin.top+21+size.margin.mid)
                        .attr('class', 'mediumText')
                    bbItem.append('text')
                        .html(d => format('pv', d.pval))
                        .attr('x',180).attr('y', (d,i) => size.unit*i+size.margin.top+21+size.margin.mid)
                        .attr('class', 'smallText pval')
                    bbItem.append('text')
                        .html(d => format('bt', d.beta))
                        .attr('x',230).attr('y', (d,i) => size.unit*i+size.margin.top+21+size.margin.mid)
                        .attr('class', 'smallText beta')
                    bbItem.append('text')
                        .html(d => format('pp', d.pip))
                        .attr('x',270)
                        .attr('y', (d,i) => size.unit*i+size.margin.top+21+size.margin.mid)
                        .style('display', extra.pip ? 'block' : 'none')
                        .attr('class', 'smallText pip')
                    bbItem.append('text')
                        .html(d => format('af', d.af))
                        .attr('x', getExtra(310, 270, 230))
                        .attr('y', (d,i) => size.unit*i+size.margin.top+21+size.margin.mid)
                        .attr('class', 'smallText af')
                        .style('display', extra.af ? 'block' : 'none')
                    bbItem.append('circle')
                        .attr('cx', 12).attr('cy', (d,i) => size.unit*i+size.margin.top+15+size.margin.mid)
                        .attr('r', '9px')
                        .attr('fill', (d,i) => colorBiobank(i))
                    return bbItem
                },
                function(update){
                    update.select('.af').html(d => format('af', d.af))
                    update.select('.beta').html(d => format('bt', d.beta))
                    update.select('.pval').html(d => format('pv', d.pval))
                    update.select('.pip').html(d => format('pp', d.pip))
                }
            )
    };

    function drawAxis () {

        var axis = d3.axisLeft().scale(scalePvalToUI).ticks(6, x => Math.log10(x));
        
        d3.select('#axis03')
            .attr('transform', 'translate(' + size.margin.left + ', 0)')
            .transition().duration(1500)
            .call(axis)

        d3.select('#midLocus_line')
            .transition().duration(1500)
            .attr('x1', scalePosToUI(locus.pos))
            .attr('x2', scalePosToUI(locus.pos))
        
        d3.select('#midLocus_rect')
            .transition().duration(1500)
            .attr('x', scalePosToUI(locus.pos)-30)
        
        d3.select('#midLocus_text')
            .transition().duration(1500)
            .attr('x', scalePosToUI(locus.pos))
        
        d3.select('#significance_line')
            .transition().duration(1500)
            .attr('y1', locatePval(1e-8))
            .attr('y2', locatePval(1e-8))
            .style('opacity', minPval > 1e-8 ? 0 : 1)

        d3.select('#legenda03').select('polygon')
            .attr('points', function () {
                const x = 8
                const y = 10
                var corner1 = x + ',' + y,
                    corner2 = (x+4) + ',' + (y-6),
                    corner3 = (x-4) + ',' + (y-6);
                return corner1 + ' ' + corner2 + ' ' + corner3;
        })
    }

    function drawCircles(data){

        function drawTriangle (pos, codV) {
            if (codV === undefined) return undefined
            else {
                const y = size.margin.top-3
                const corner1 = 0 + ',' + y,
                    corner2 = 4 + ',' + (y-6),
                    corner3 = -4 + ',' + (y-6);
            return corner1 + ' ' + corner2 + ' ' + corner3;
            }
        }

        function findDirection (data) {
            const minPval = d3.min(data, d => d.pval)
            var direction
            data.forEach(el => {if (el.pval === minPval) direction = el.beta > 0})
            return direction
        }

        function getValue (hover, datum, generic, yes, no) {
            if (hover === undefined) return generic
            else if (datum.pos === hover) return yes
            else return no
            // return generic
        }
        
        d3.select('#circles03').selectAll('.locusItem').data(data, d => d.pos).join(
            function(enter){
                const list = enter.append('g')
                    .attr('class', 'locusItem')
                    .attr('transform', d => 'translate(' + scalePosToUI(d.pos) + ' 0)')
                    .on('mouseenter', function(e,d) {setHover(d.pos); setInspection(d); d3.select(this).raise()})
                    .on('mouseleave', () => setHover())
                list.append('line')
                    .attr('x1', 0).attr('y1', size.margin.top+size.height+size.margin.bottom+biobanks.length*6+10)
                    .attr('x2', 0).attr('y2', size.margin.top)
                    .attr('class', 'normalLine')
                    .style('opacity', d => getValue(hover, d, 0, 1, 0));
                list.append('text')
                    .html(d => d.pos)
                    .attr('x', d => 0).attr('y', size.margin.top-12)
                    .attr('class', 'smallText')
                    .style('text-anchor','middle')
                    .style('opacity', d => hover === d.pos ? 1 : 0);
                list.append('polygon')
                    .attr('points', d => drawTriangle(d.pos, d.codV))
                    .attr('fill', 'white')
                    .style('opacity', 0).transition().duration(500).style('opacity', 1)
                    
                biobanks.forEach((bb,i) => {
                    const item = list.append('g')
                        .attr('class', bb + ' item')
                        .attr('transform', d => 'translate(0 ' + locatePval(d.values[i].pval,i) +')') 
                    item.append('circle')
                        .attr('class', 'locusCircle')
                        .attr('cx', 0)
                        .attr('cy', 0)
                        .attr('fill', colorBiobank(i))
                        .attr('r', d => getValue(hover, d, 3, 5, 2))
                        .attr('stroke', colorBiobank(i))
                        .attr('stroke-width', d => {
                            if ((d.values[i].beta > 0) === findDirection(d.values)) return 0
                            else if (Number.isNaN(d.values[i].beta)) return 0
                            else return 6
                        })
                        .style('opacity', 0).transition().duration(1000).style('opacity', d => getValue(hover, d, 1, 1, 0.4))
                    item.append('text')
                        .attr('class', 'smallText')
                        .attr('x', 8)
                        .attr('y', 3)
                        .text(d => format('bb', bb) + ', ' + format('pv', d.values[i].pval))
                        .style('font-weight', 600)
                        .style('pointer-events', 'none')
                        .style('opacity', 0).transition().duration(1000).style('opacity', d => getValue(hover, d, 0, 1, 0))
                })
            },
            function(update){
                update
                    .on('mouseenter', function(e,d) {setHover(d.pos); setInspection(d); d3.select(this).raise()})
                    .transition().duration(500)
                    .attr('transform', d => 'translate(' + scalePosToUI(d.pos) + ' 0)')
                update.select('line')
                    .transition().duration(500)
                    .style('opacity', d => getValue(hover, d, 0, 1, 0));
                update.select('text')
                    .html(d => d.pos)
                    .transition().duration(500)
                    .style('opacity', d => hover === d.pos ? 1 : 0);
                update.select('polygon')
                    .attr('points', d => drawTriangle(d.pos, d.codV))

                biobanks.forEach((bb,i) => {
                    const item = update.select('.' + bb)
                        .transition().duration(500)
                        .attr('transform', d => 'translate(0 ' + locatePval(d.values[i].pval,i) +')')
                    item.select('circle')
                        .transition().duration(500)
                        .attr('r', d => getValue(hover, d, 3, 5, 2))
                        .attr('stroke-width', d => {
                            if ((d.values[i].beta > 0) === findDirection(d.values)) return 0
                            else if (Number.isNaN(d.values[i].beta)) return 0
                            else return 6
                        })
                        .style('opacity', d => getValue(hover, d, 1, 1, 0.4));
                    item.select('text')
                        .text(d => format('bb', bb) + ', ' + format('pv', d.values[i].pval))
                        .transition().duration(500)
                        .style('opacity', d => getValue(hover, d, 0, 1, 0))
                })
            }
        )
            

    }



    useEffect (()=>{

        d3.select('#view03').transition().duration(500).style('opacity',1);

        drawAxis()
        drawPaths(paths)
        drawCircles(circles)
        drawInspectionList(inspection) 

    })

    return (
         <div id="view03" className="section">
            <div className="section_header">
                <h1>Locus view</h1>
            </div>
            <div className="section_content">
                <div style={{
                    display:'flex',
                    alignItems:'flex-end',
                    marginLeft: size.margin.left
                    }}>
                    <div id="legenda03">
                        <div style={{display:'flex', alignItems:'center', width:150}}>
                            <svg className='legendaSvg'>
                                <polygon style={{fill:'white'}}></polygon>
                            </svg>
                            <p className='smallText'>Special coding variant</p>
                        </div>
                        <div style={{display:'flex', alignItems:'center', width:150}}>
                            <svg className='legendaSvg'>
                                <circle cx={8} cy={8} r={3} style={{fill:'white', strokeWidth:'7px', stroke:'white', strokeDasharray:'0.5,1.5'}}></circle>
                            </svg>
                            <p className='smallText'>Beta with opposite sign</p>
                        </div>
                    </div>
                    <div style={{flexGrow:'3', textAlign:'end'}}>
                        <p className='smallText'>View size: {d3.format(",.2r")(locus.high-locus.low)} loci</p>
                    </div>
                </div>
                <svg id="chart03" width={size.width} height={size.height + size.margin.top + size.margin.bottom + size.unit}>
                    <g id="title03">
                        <text x={0} y={size.margin.top+size.margin.mid - 10} className='smallText'>Color</text>
                        <text x={35} y={size.margin.top+size.margin.mid - 10} className='smallText'>Biobank</text>
                        <text x={180} y={size.margin.top+size.margin.mid - 10} className='smallText'>P-value</text>
                        <text x={230} y={size.margin.top+size.margin.mid - 10} className='smallText'>Beta</text>
                        <text x={270} y={size.margin.top+size.margin.mid - 10} className='smallText' style={{display: extra.pip ? 'block' : 'none'}}>PIP</text>
                        <text x={getExtra(310, 270, 230)} y={size.margin.top+size.margin.mid - 10} className='smallText' style={{display: extra.af ? 'block' : 'none'}}>AF</text>
                        <text x={size.margin.left-9} y={size.margin.top+size.height+size.margin.bottom+2} className='smallText' style={{textAnchor: 'end'}}>NaN</text>
                    </g>
                    <g id="lines03">
                        <line x1={size.margin.left} x2={size.width} y1={size.margin.top -1.5} y2={size.margin.top -1.5} className='thickLine'></line>
                        <line x1={0} x2={size.margin.left - size.margin.gutter} y1={size.margin.top+size.margin.mid -1.5} y2={size.margin.top+size.margin.mid -1.5} className='thickLine'></line>
                        <line x1={0} x2={size.margin.left - size.margin.gutter} y1={size.margin.top -1.5} y2={size.margin.top+ -1.5} className='thickLine'></line>
                        <line x1={size.margin.left} x2={size.width} y1={4} y2={4} className='normalLine'></line>
                        <line x1={size.margin.left} x2={size.width} y1={25} y2={25} className='normalLine'></line>
                    </g>
                    <g id="locus03">
                        <text id="locus_name" className="textMedium" x={0} y={size.margin.top+15}></text>
                        <g id="links03">
                            <text id="link_finngen" x={0} y={size.margin.top+80} className='smallText linkText'>→ FinnGen</text>
                            <text id="link_opentargets" x={0} y={size.margin.top+92} className='smallText linkText'>→ OpenTargets</text>
                        </g>
                        <g id="specifics03" />
                    </g>
                    <g id="biobanks03"></g>
                    <g id="thumbnail03">
                        <g id="backgrounds03">
                            <rect 
                                id = 'NaNrect03'
                                x = {size.margin.left} 
                                y = {size.margin.top + size.height + size.margin.bottom -5} 
                                width = {size.width-size.margin.left-1} 
                                height = {biobanks.length*6+15} 
                                fill = {settings.blue1}
                                style ={{opacity: 0.1}}
                                />
                            <rect 
                                x = {size.margin.left}
                                y = {size.margin.top}
                                width = {size.width-size.margin.left-1}
                                height = {size.height}
                                fill = {settings.blue1}
                                style ={{opacity: 0.1}}
                                />
                        </g>
                        <line 
                            id = "significance_line" 
                            className = 'normalLine' 
                            style = {{strokeDasharray:'2'}}
                            x1 = {size.margin.left} 
                            x2 = {size.width} 
                            />
                        <g id="paths03"></g>
                        <g id="circles03" />
                    </g>
                    <g id="position03">
                        <text x={size.margin.left} y={18} className='smallText'>{locus.low}</text>
                        <text x={size.width} y={18} className='smallText' style={{textAnchor: 'end'}}>{locus.high}</text>
                        <line id='midLocus_line' style={{stroke: settings.pink0, strokeWidth: 1}} y1={8} y2={size.margin.top+size.height+size.margin.bottom+biobanks.length*6+10} />
                        <rect id='midLocus_rect' style={{fill: settings.pink0}} y={8} height={13} width={60} rx={3} />
                        <text id='midLocus_text' style={{textAnchor: 'middle'}} className='smallText' y={18}>{locus.pos}</text>
                    </g>
                    <g id="axis03"></g>
                </svg>
            </div>
        </div> 
        )
}
export default View03;